<div class="site-wrapper">
  <!-- <ngx-loading-bar color="#FFF" [includeSpinner]="false"></ngx-loading-bar> -->
  <app-header></app-header>
  <div class="site-container">
    <app-sidebar class="d-none d-md-block side-bar" [class.minify]="minifySidebar" [minify]="minifySidebar"></app-sidebar>
    <div id="scrollArea" class="site-content" [class.specific]="oldLayout">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
<!-- <vip-modal></vip-modal> -->